import React from "react"

export default ({ show, toggleShow, full = true, title, description, acceptTitle, onAccept, rejectTitle }) => {

  return (
    show ? <div className={`modal flexed fl-c` + (full && ' full')}>
      <div className={`p-45` + (full && ' bg-top-nav w-33 shadow-mild radius-8 popIn')}>
        <h3 className="m-0 text-shadow font-16 px-8">{title}</h3>
        <hr className="mb-0" />
        <div className="p-32 modal-content">
          <p>{description}</p>
        </div>
        <div className="ltr mt-32 px-8">
          {onAccept && <button className="bd-none iran-sans radius-4 font-10 text-top-nav bg-tomato"
            onClick={onAccept}
            style={{ padding: '5px 0', width: 85 }}>{acceptTitle || 'تایید'}</button>}
          <button className="bd-none bg-none icon-button iran-sans radius-4 font-10 text-top-nav ml-16"
            onClick={() => toggleShow(false)}
            style={{ color: '#ffb1ccbb', padding: '5px 0', width: 85, border: '1px solid #ffb1ccbb' }}>{rejectTitle || 'انصراف'}</button>
        </div>
      </div>
    </div> : <></>
  )
}
